<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>

            <fui-row [label]="'wbo.report.edit.options'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-entity-sub-group-by-report-criteria></wbo-entity-sub-group-by-report-criteria>
                    </fui-column>
                    <fui-column>
                        <wbo-checkbox-edit-control [formControlName]="'hideEmployeesWithNoActivity'"
                                                   [(ngModel)]="model.data.hideEmployeesWithNoActivity">
                        </wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <wbo-employee-report-selection></wbo-employee-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
